import React from 'react';

var SpinnerLockIcon = _ref => {
  var {
    title
  } = _ref;
  return React.createElement("svg", {
    "aria-labelledby": "spinner-lock-title",
    height: "48px",
    role: "img",
    version: "1.1",
    viewBox: "0 0 33 48",
    width: "33px",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", {
    id: "spinner-lock-title"
  }, title), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, React.createElement("g", {
    transform: "translate(-171.000000, -269.000000)"
  }, React.createElement("g", {
    transform: "translate(163.000000, 268.000000)"
  }, React.createElement("rect", {
    height: "50",
    width: "50",
    x: "0",
    y: "0"
  }), React.createElement("path", {
    d: "M25.2599,31.1042 L25.2599,36.9792",
    stroke: "#B4B4B4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }), React.createElement("g", {
    stroke: "#B4B4B4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    transform: "translate(9.000000, 1.500000)"
  }, React.createElement("path", {
    d: "M31.1080271,21.209925 C31.1080271,20.2219458 30.2013188,19.4200083 29.0831104,19.4200083 L2.75919375,19.4200083 C1.64098542,19.4200083 0.734277083,20.2219458 0.734277083,21.209925 L0.734277083,44.4700292 C0.734277083,45.461925 1.64392292,46.2658208 2.76604792,46.2658208 L29.0831104,46.2658208 C30.2013188,46.2658208 31.1080271,45.5686542 31.1080271,44.5796958 L31.1080271,21.209925 L31.1080271,21.209925 Z"
  }), React.createElement("path", {
    d: "M6.33354375,19.4203021 L6.33354375,9.83230208 C6.33354375,4.53696875 10.6262104,0.24528125 15.9215437,0.24528125 L15.9215437,0.24528125 C21.2158979,0.24528125 25.5085646,4.53696875 25.5085646,9.83230208 L25.5085646,19.4203021"
  }))))));
};

export { SpinnerLockIcon };